function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#757575;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-14.176)"
}, React.createElement("g", {
  transform: "translate(14.176)"
}, React.createElement("path", {
  className: "a",
  d: "M92.038,229.948c-4.928.3-11.413,5.23-17.668,8.063-7.662,3.466-19.6.678-19.6.678,1.838-.862,9.317-2.644,10.825-3.309,8.007-3.52,7.332-10.865,3.518-10.8-5.042.085-8,1.322-18.051,2.693-7.62,1.036-16.633.657-20.956,2.308-6.1,2.331-15.934,18.014-15.934,18.014l15.2,14.724s9.407-9.263,13.984-9.263c10.43,0,10.853-.144,20.541-.667,4.115-.22,4.978-.389,7.333-1.188,12.554-4.241,26.035-15.546,26.283-16.906C98.091,231.143,94.647,229.786,92.038,229.948Z",
  transform: "translate(-14.176 -172.315)"
}), React.createElement("path", {
  className: "a",
  d: "M135.213,15.549a.979.979,0,0,0,.947.512l6.953-.23a.984.984,0,0,0,.407-1.836l-1-.609,4.162-6.811L153.4,18.288a.983.983,0,0,0,1.344.357l7.164-4.152a1,1,0,0,0,.459-.6.984.984,0,0,0-.1-.745L155.9,2.086C155.179.846,153.9,0,151.593,0H139.577a.981.981,0,0,0-.821.468L134.023,8.21l-1.007-.61a.986.986,0,0,0-1.349,1.326Z",
  transform: "translate(-104.236)"
}), React.createElement("path", {
  className: "a",
  d: "M213.333,79.637l-3.271,6.144a.985.985,0,0,0,1.388,1.269l1.026-.567,3.823,7.006-13.5-.019a.984.984,0,0,0-.983.983l.021,8.286a.982.982,0,0,0,.989.979l12.762,0c1.438,0,2.874-.986,3.943-2.7,2.143-3.42,5.147-8.827,6.018-10.4a1,1,0,0,0,0-.946L221.2,81.709l1.03-.569a.984.984,0,0,0,.446-1.092.9.9,0,0,0-.087-.224.98.98,0,0,0-.838-.512l-7.508-.237A.986.986,0,0,0,213.333,79.637Z",
  transform: "translate(-158.147 -60.672)"
}), React.createElement("path", {
  className: "a",
  d: "M98.506,95.012a.983.983,0,0,0,.825.454l9.076-.009,0,1.174a.994.994,0,0,0,.754.919,1.006,1.006,0,0,0,.235.027.973.973,0,0,0,.85-.485l3.809-6.467A.978.978,0,0,0,114,89.553l-3.82-5.815a.983.983,0,0,0-1.779.608l0,1.161-7.984,0,6.465-11.856a.986.986,0,0,0-.394-1.333L99.21,68.362a1,1,0,0,0-.747-.078.982.982,0,0,0-.585.476L91.787,79.973c-.685,1.263-.511,3,.477,4.755C94.232,88.249,97.536,93.492,98.506,95.012Z",
  transform: "translate(-73.409 -52.363)"
})));

var SvgOwnershipImg = function SvgOwnershipImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 83.403,
    height: 90,
    viewBox: "0 0 83.403 90",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOwnershipImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ownership_img.6b90035c.svg";
export { ForwardRef as ReactComponent };